import { render, staticRenderFns } from "./b.vue?vue&type=template&id=0bb87e46&scoped=true&"
import script from "./b.vue?vue&type=script&lang=js&"
export * from "./b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb87e46",
  null
  
)

component.options.__file = "b.vue"
export default component.exports